import { StatChipSkeleton } from "../primitives";
import styles from "./style.module.scss";

/** Row of placeholder stat chips, shared by the header skeleton. */
export function StatChipSkeletonRow({ count = 3 }: { count?: number }) {
  return (
    <span className={styles.stats}>
      {Array.from({ length: count }).map((_, index) => (
        <StatChipSkeleton key={index} width={index === 0 ? 104 : 88} />
      ))}
    </span>
  );
}
